

<script setup>

    // Parent component of UserDataShow and UserDataEdit:
    // contains state-managing logic to switch between each component on button press.
    // States: 0 for UserDataShow, 1 for UserDataEdit.
    // Also shows error on emit. Emits handle state switching.

    import UserDataShow from './UserDataShow.vue';
    import UserDataEdit from './UserDataEdit.vue';
    import { ref } from 'vue';

    const state = ref(0);
    const saveConfirm = ref(0);
    const props = defineProps(['fetchUrl', 'updateUrl', 'userNumber', 'currentUserIsAdmin']);
    const saveError = ref(false);
</script>

<template>
    <UserDataShow
      v-if="state == 0"
      @switch-to-edit="state = 1"
      :fetchUrl="props.fetchUrl"
      :userNumber="props.userNumber" />
    <UserDataEdit
      v-if="state == 1"
      @switch-to-show="state = 0"
      @successful-save="saveError = false, saveConfirm = 1"
      @save-error="saveError = true"
      :fetchUrl="props.fetchUrl"
      :updateUrl="props.updateUrl"
      :userNumber="props.userNumber"
      :currentUserIsAdmin="props.currentUserIsAdmin" />
    <!-- <p v-if="saveConfirm != 0">Daten erfolgreich gespeichert!</p> -->
    <div class="alert alert-success" role="alert" v-if="saveConfirm != 0">
        Daten erfolgreich gespeichert!
    </div>
    <!-- <p v-if="saveError === true">Leider ist ein Fehler passiert. Wir bitten um Entschuldigung.</p> -->
    <div class="alert alert-danger" role="alert" v-if="saveError === true">
        Leider ist ein Fehler passiert. Wir bitten um Entschuldigung.
    </div>

</template>
